module.exports = __webpack_public_path__ + "img/de_Logo_OVT.bb85c074.png";